module.exports = __webpack_public_path__ + "media/images/projects/12-header-8d99ec63ce476c29b3974e31b577689e.jpg";